// Action Types
export const API_REQUEST = 'API_REQUEST';
export const API_RESPONSE_FAILURE = 'API_RESPONSE_FAILURE';
export const GET_SUCCESS = 'GET_SUCCESS';
export const POST_SUCCESS = 'POST_SUCCESS';
export const UPDATE_SUCCESS = 'UPDATE_SUCCESS';
export const DELETE_SUCCESS = 'DELETE_SUCCESS';
export const API_FETCH_ERROR = 'API_FETCH_ERROR';
export const API_SUCCESS = 'API_SUCCESS';
export const API_FAILURE = 'API_FAILURE';   

export const apiRequest = (operation, key = 'default',message="") => ({
  type: API_REQUEST,
  payload: { operation, key,message },
});

export const apiSuccess = (operation, key = 'default', message = '') => ({
  type: API_SUCCESS,
  payload: { operation, key, message },
});


export const apiResponseFailure = (error, operation, key = 'default') => ({
    type: API_RESPONSE_FAILURE,
    payload: { error, operation, key }, // Include the error, operation, and key
});

export const apiFetchError = (message, operation, key = 'default') => ({
    type: API_FETCH_ERROR,
    payload: { message, operation, key }, // key defaults to 'default'
});

export const getSuccess = (message, key = 'default') => ({
    type: GET_SUCCESS,
    payload: { message, key }, // Include a success message and key
});

export const postSuccess = (message, key = 'default') => ({
    type: POST_SUCCESS,
    payload: { message, key }, // Include a success message and key
});

export const updateSuccess = (message, key = 'default') => ({
    type: UPDATE_SUCCESS,
    payload: { message, key }, // Include a success message and key
});

export const deleteSuccess = (message, key = 'default') => ({
    type: DELETE_SUCCESS,
    payload: { message, key }, // Include a success message and key
});

export const resetApiState = () => ({
    type: 'RESET_API_STATE',
});